<app-theme-option [categories]="themeOptions.optionsConfiguration[optionType].categories" [label]="themeOptions.optionsConfiguration[optionType].label" [information]="'PIXELS'">
  <div app-theme-option-content>
    <app-show-details-option [showDetails]="showDetails" (sendShowDetails)="receiveShowDetails($event)">
      <div app-show-details-option-content>
        <app-number [value]="themeOptions.options().legend.labels.padding" (sendValue)="receiveValue($event)" [color]="color" [min]="0" [max]="50" [step]="5"></app-number>
      </div>
    </app-show-details-option>
  </div>
</app-theme-option>

<div *ngIf="showDetails">
  <app-theme-option [categories]="themeOptions.optionsConfiguration[optionType].categoriesAndLabel" [information]="'PIXELS'" [label]="type | chart" [dark]="4" *ngFor="let type of themeOptions.limitedTo(optionType)">
    <div app-theme-option-content>
      <app-number [value]="themeOptions.options(type).legend.labels.padding" (sendValue)="receiveValue($event, type)" [color]="color" [min]="0" [max]="50" [step]="5"></app-number>
    </div>
  </app-theme-option>
</div>